import { render, staticRenderFns } from "./DashboardLatestBlogsSkeleton.vue?vue&type=template&id=4da954e2&scoped=true"
import script from "./DashboardLatestBlogsSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardLatestBlogsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardLatestBlogsSkeleton.vue?vue&type=style&index=0&id=4da954e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da954e2",
  null
  
)

export default component.exports